export const readEmpty = async (skip,query,batas, thisCompany) => {
    if(batas === "Yes"){
        try{
            const res = await fetch( 
                `${process.env.REACT_APP_BACKEND_URL}/listKlienEmptySpecific?skip=${skip}&query=${query}&thisCompany=${thisCompany}`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );
            return await res.json();
        } catch(error){
            throw new Error(error);
        }
    }else{
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listCompanyEmpty?skip=${skip}&query=${query}&batas=${batas}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}
}